export const defaultNotificationOptions = [
    {
      "id": "orderTracking",
      "label": "Order Tracking"
    },
    {
      "id": "order@recommendedProduct",
      "label": "One Click Order"
    },
    {
      "id": "order",
      "label": "All Products"
    },
    {
      "id": "homePage",
      "label": "Home Page"
    },
    {
      "id": "notification",
      "label": "Notification Section"
    },
    {
      "id": "recommendedOrderBasket@unforgivableSKU-unforgivableSKUProduct-9",
      "label": "Hot Selling Basket"
    },
    {
      "id": "recommendedOrderBasket@mustTry-mustTryProduct-8",
      "label": "Ordered Near You Basket"
    },
    {
      "id": "recommendedOrderBasket@newLaunch-newLaunchProduct-10",
      "label": "New Launches Basket"
    },
    {
      "id": "recommendedOrderBasket@regular-regularBuyProduct-0",
      "label": "You Regularly Order Basket"
    },
    {
      "id": "CategoryWiseProduct",
      "label": "Filters for Brand, Category, Pack Size"
    },
    {
      "id": "skuSelection",
      "label": "Curated Basket"
    }
  ];
